import React from 'react';

import type { ContentPageProps } from 'types/content-pages';

export default function ContentPage({ siteContent }: ContentPageProps) {
  return (
    <div className='content-page' id="wp-content">
      <div dangerouslySetInnerHTML={{ __html: siteContent }} />
    </div>
  );
}
